module.exports = __webpack_public_path__ + "static/media/delete-agenda.80b41e94.svg";